import type React from 'react';
import { useTranslation } from 'react-i18next';
import {
    Fieldset,
    Label,
    ToggleButton,
    ToggleButtonGroup,
} from '@heroui/react';
import type { ProductType } from '@/api/models';
import { getNodeTestIdProp } from '@/utils';
import {
    ALL_FILTER_VALUE,
    PRODUCT_TYPE_CHIP,
    PRODUCT_TYPE_OPTIONS,
} from '../productsMeta';
import { toProductTypeFilter } from './productFiltersMeta';

type TypeFilterToggleProps = {
    value: ProductType | null;
    onChange: (type: ProductType | null) => void;
};

/** The filters drawer's Type field: All / Simple / Variable, one always on. */
export const TypeFilterToggle: React.FC<TypeFilterToggleProps> = ({
    value,
    onChange,
}) => {
    const { t } = useTranslation('pages');
    const label = t('products.components.productTable.filters.typeLabel');

    return (
        <Fieldset className="flex-none gap-0">
            <Fieldset.Legend className="mb-2">
                <Label elementType="span">{label}</Label>
            </Fieldset.Legend>
            <ToggleButtonGroup
                aria-label={label}
                disallowEmptySelection
                fullWidth
                onSelectionChange={(keys) =>
                    onChange(toProductTypeFilter(keys))
                }
                selectedKeys={[value ?? ALL_FILTER_VALUE]}
                selectionMode="single"
                {...getNodeTestIdProp('product-filters-type')}
            >
                <ToggleButton id={ALL_FILTER_VALUE}>
                    {t('products.components.productTable.filters.all')}
                </ToggleButton>
                {PRODUCT_TYPE_OPTIONS.map((option) => (
                    <ToggleButton id={option} key={option}>
                        <ToggleButtonGroup.Separator />
                        {t(PRODUCT_TYPE_CHIP[option].labelKey)}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
        </Fieldset>
    );
};
